import { parseUserId } from "../../misc/util";

const state = {
  userId: parseUserId(),
};

const getters = {
  getUserId: (rootState) => rootState.userId
};

const mutations = {
  SET_USER_ID(rootState, payload) {
    rootState.userId = payload;
  }
};

const actions = {
  changeUserId({ commit }, payload) {
    if (payload === null) {
      return commit("SET_USER_ID", parseUserId());
    }

    return commit("SET_USER_ID", payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
